"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CautionIcon = function CautionIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "40",
    viewBox: "0 0 20 40",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 13C10.4375 13 10.8438 13.25 11.0625 13.625L17.8125 25.125C18.0312 25.5312 18.0312 26 17.8125 26.375C17.5938 26.7812 17.1875 27 16.75 27H3.25C2.78125 27 2.375 26.7812 2.15625 26.375C1.9375 26 1.9375 25.5312 2.15625 25.125L8.90625 13.625C9.125 13.25 9.53125 13 10 13ZM10 17C9.5625 17 9.25 17.3438 9.25 17.75V21.25C9.25 21.6875 9.5625 22 10 22C10.4062 22 10.75 21.6875 10.75 21.25V17.75C10.75 17.3438 10.4062 17 10 17ZM11 24C11 23.4688 10.5312 23 10 23C9.4375 23 9 23.4688 9 24C9 24.5625 9.4375 25 10 25C10.5312 25 11 24.5625 11 24Z",
    fill: "#CA4615"
  }));
};

var _default = CautionIcon;
exports["default"] = _default;